import { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Drawer from '@material-ui/core/Drawer';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Table from './components/Table';
import ContactForm from './components/ContactForm';
import styles from './styles';
import FiltersBar from 'components/FiltersBar/FiltersBar';
import { deleteSettingsDwlContact } from 'store/settings/settingsOperations';

const DwlPointOfContact = ({ classes, pageType, control, errors, openSnackbar }) => {
  const dispatch = useDispatch();
  const { locationSettings, dwlUsers } = useSelector((state) => state.settings);

  const [tableUsers, setTableUsers] = useState(
    (locationSettings?.dwlVerifyContacts || [])
      .map((_id) => dwlUsers.find((dwlUser) => dwlUser._id === _id))
      .filter((user) => !!user)
  );
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setTableUsers(
      (locationSettings?.dwlVerifyContacts || [])
        .map((_id) => dwlUsers.find((dwlUser) => dwlUser._id === _id))
        .filter((user) => !!user)
        .filter((user) => searchValue
          ? ( new RegExp(searchValue, 'i').test(user.profile.fullName || user.username) ||
              new RegExp(searchValue, 'i').test(user.profile.email) ||
              new RegExp(searchValue, 'i').test(user.profile.role.roleName))
          : true
        )
    );
  }, [locationSettings, dwlUsers, searchValue]);

  const [drawer, setDrawer] = useState({ open: false });

  const tableHeadCells = useMemo(() => {
    return [
      { id: 'name', label: 'Name', align: 'left' },
      { id: 'email', label: 'Email', align: 'left' },
      { id: 'userRole', label: 'User Role', align: 'left' },
      { id: 'action', label: 'Delete' },
    ];
  }, []);

  const openDrawer = () => () => setDrawer({ open: true });

  const closeDrawer = () => setDrawer({ open: false });

  const deleteDwlContact = async (userId) => {
    try {
      await dispatch(deleteSettingsDwlContact({ userId })).then(closeDrawer);
      openSnackbar('success', 'Successfully Deleted!');
    } catch (err) {
      openSnackbar('error', err?.response?.data?.message || err.message);
    }
  };

  const rows = useMemo(() => {
    return tableUsers.map((user) => ({
      key: user._id,
      cells: [
        { align: 'left', children: user.profile.fullName || user.username },
        { align: 'left', children: user.profile.email },
        { align: 'left', children: user.profile.role.roleName },
        {
          className: 'action-cell',
          onClick: () => deleteDwlContact(user._id),
          children: (
            <div className="cell-button">
              <DeleteIcon className="cell-button__icon" alt="Delete" />
              Delete
            </div>
          ),
        },
      ],
    }));
  }, [tableUsers]);

  return (
    <div>
      <Grid container className={classes.pb3}>
        <Grid item xs={12} md={8}>
          <Typography variant="h3">DWL Point of Contact</Typography>
        </Grid>
      </Grid>
      <Grid container className={classes.pb4}>
        <Grid item xs={12}>
          <FiltersBar
            openDrawer={openDrawer}
            updateSearchValue={setSearchValue}
            noFilters={true}
            addButton={true}
          />
        </Grid>
      </Grid>
      <Grid container className={classes.pb4}>
        <Table headCells={tableHeadCells} rows={rows} editLocation={openDrawer} />
      </Grid>
      <Drawer anchor="right" open={!!drawer?.open}>
        <ContactForm
          type={drawer.type}
          closeDrawer={closeDrawer}
          locationSettings={locationSettings}
          dwlUsers={dwlUsers}
          openSnackbar={openSnackbar}
        />
      </Drawer>
    </div>
  );
};

export default withStyles(styles)(DwlPointOfContact);
